export default {
  init() {
    document.getElementById("menu-btn").onclick = () => {
      document.getElementById("deployed-header").classList.toggle("hidden");
    };

    document.getElementById("deployed-header-close-btn").onclick = () => {
      document.getElementById("deployed-header").classList.toggle("hidden");
    };

    if (document.querySelector(".gallery")) {
      $(".gallery").slick({
        initialSlide: document.querySelector(".gallery").dataset.initSlide,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: ".gallery-control",
      });

      $(".gallery-control").slick({
        initialSlide: document.querySelector(".gallery").dataset.initSlide,
        arrows: false,
        centerMode: true,
        slidesToShow: 7,
        slidesToScroll: 1,
        asNavFor: ".gallery",
        focusOnSelect: true,
        //autoplay: true,
        autoplaySpeed: 4000,
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js